import _ from 'lodash';
import type {
  NewStaffMemberModel,
  StaffMemberListModel,
  StaffMemberModel,
} from '../app/types/staff-member.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const checkAddress = (value: StaffMemberModel) => {
  if (
    !_(value.address)
      .values()
      .some(val => !!val)
  ) {
    value.address = null;
  }

  return value;
};

const staffApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchStaffMember: builder.query<StaffMemberModel, string>({
      query: key => ({ url: `/staffMember/${key}` }),
      providesTags: [CacheTag.User, CacheTag.CurrentUser],
    }),
    postStaffMember: builder.mutation<StaffMemberModel, NewStaffMemberModel>({
      query: post => ({
        url: '/staffMember',
        method: 'POST',
        body: {
          ...post,
          staffMember: checkAddress(post.staffMember),
        },
      }),
      invalidatesTags: [CacheTag.User],
    }),
    putStaffMember: builder.mutation<StaffMemberModel, StaffMemberModel>({
      query: put => ({
        url: '/staffMember',
        method: 'PUT',
        body: checkAddress(put),
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser],
    }),
    fetchStaffMembers: builder.query<StaffMemberListModel[], string>({
      query(params) {
        return params ? `/staffMember?${params}` : `/staffMember`;
      },
      providesTags: [CacheTag.User, CacheTag.CurrentUser],
    }),
    deleteStaffMember: builder.mutation<void, string>({
      query: key => ({
        url: `/staffMember/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CacheTag.User],
    }),
    releaseStaffMemberEmail: builder.mutation<StaffMemberModel, string>({
      query: key => ({
        url: `/staffMember/${key}/ReleaseEmail`,
        method: 'PUT',
      }),
      invalidatesTags: [CacheTag.User],
    }),
    putToggleActiveStaffMember: builder.mutation<StaffMemberModel, StaffMemberListModel>({
      query: model => ({
        url: `/staffMember/ToggleActive`,
        method: 'PUT',
        body: model,
      }),
      invalidatesTags: [CacheTag.User],
    }),
  }),
});

export const {
  useFetchStaffMemberQuery,
  usePostStaffMemberMutation,
  usePutStaffMemberMutation,
  useFetchStaffMembersQuery,
  useDeleteStaffMemberMutation,
  useReleaseStaffMemberEmailMutation,
  usePutToggleActiveStaffMemberMutation,
} = staffApi;
